// src/pages/Policies.jsx
import React from "react";

export default function Policies() {
  return (
    <main style={{maxWidth: 900, margin: "0 auto", padding: "2rem 1rem"}}>
      <h1 style={{marginBottom: "1rem"}}>Customer Service & Policies</h1>
      <p style={{opacity: 0.9, marginBottom: "2rem"}}>
              </p>

      {/* Contact */}
      <section id="contact" style={{marginBottom: "2rem"}}>
        <h2>Contact</h2>
        <p><strong>Business:</strong> Unlimited Levels Inc.</p>
        <p><strong>Email:</strong> <a href="mailto:info@unlimitedlevels.co">info@unlimitedlevels.co</a></p>
        <section id="contact" style={{marginBottom: "2rem"}}>
    {/* ✅ WhatsApp-only line */}
  <p>
    <strong>WhatsApp (messages only):</strong>{" "}
    <a href="https://wa.me/19415004861" rel="noreferrer" target="_blank">
      +1 (941) 500-4861
    </a>{" "} — no voice calls; responses during business hours (Mon-Fri 9am-5pm)
  </p>
</section>
        <p><strong>Mailing Location:</strong> Sarasota, FL, USA</p>
        <p>For any questions about your order, email us with your order number.</p>
      </section>

      {/* Returns */}
      <section id="returns" style={{marginBottom: "2rem"}}>
        <h2>Return Policy</h2>
        <p>
          Most products are custom or made-to-order. As such, <strong>all sales are final</strong>.
          If an item arrives damaged or defective, contact us within <strong>7 days of delivery</strong> so we can
          evaluate and resolve (repair, replacement, or partial refund as appropriate).
        </p>
      </section>

      {/* Refunds / Disputes */}
      <section id="refunds" style={{marginBottom: "2rem"}}>
        <h2>Refund &amp; Dispute Policy</h2>
        <p>
          Refunds are issued only for verified manufacturing defects or shipping damage.
          We work to resolve concerns promptly and fairly. Please email{" "}
          <a href="mailto:info@unlimitedlevels.co">info@unlimitedlevels.co</a> before opening a card dispute so we can help quickly.
        </p>
      </section>

      {/* Cancelation */}
      <section id="cancelation" style={{marginBottom: "2rem"}}>
        <h2>Cancelation Policy</h2>
        <p>
          Orders may be canceled within <strong>24 hours</strong> of purchase if production has not begun.
          After manufacturing or fulfillment starts, cancelations are not possible.
        </p>
      </section>

      {/* Legal / Export */}
      <section id="legal" style={{marginBottom: "2rem"}}>
        <h2>Legal &amp; Export Restrictions</h2>
        <p>
          Some products may be subject to local import, customs, or use restrictions. Customers are responsible for
          ensuring compliance with their local laws. International shipments may incur duties/taxes assessed by your country.
        </p>
      </section>

      {/* Promotions */}
      <section id="promotions" style={{marginBottom: "2rem"}}>
        <h2>Promotions</h2>
        <p>
          Promotional codes must be applied at checkout before payment and cannot be combined with other offers.
          Codes are valid only until their stated expiration date and have no cash value.
        </p>
      </section>

      {/* Privacy */}
      <section id="privacy" style={{marginBottom: "2rem"}}>
        <h2>Privacy Policy</h2>
        <p>
          We collect basic order information (name, email, shipping details) to fulfill your purchase.
          Payments are processed securely by Stripe; we do not store card numbers.
          For privacy requests, email <a href="mailto:info@unlimitedlevels.co">info@unlimitedlevels.co</a>.
        </p>
      </section>

      {/* Terms */}
      <section id="terms" style={{marginBottom: "2rem"}}>
        <h2>Terms of Service</h2>
        <p>
          By purchasing from Unlimited Levels Inc., you agree to our policies on returns, refunds, cancelations, promotions,
          and legal/export restrictions above. Product images are for illustration; actual finishes may vary slightly.
          Estimated production and shipping times are not guarantees and may change.
        </p>
      </section>

      <hr style={{margin: "2rem 0"}} />
      <p style={{fontSize: 12, opacity: 0.7}}>
        Last updated {new Date().toLocaleDateString()}.
      </p>
    </main>
  );
}
